import React from 'react';
import './Header.css';
import banner from '../img/banner_novo.png';
import { CONNECT_INFO } from '../constants/connect';

export default function Header() {
  return (
    <header className="app-header" aria-label={CONNECT_INFO.brand}>
      <div className="header-left">
        <img src={banner} alt={CONNECT_INFO.brand} className="header-banner" />
      </div>
      <div className="header-right" />
    </header>
  );
}
